function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M390.084,198.765l3.74,10.65c2.695,2.207,5.344,4.507,7.852,7.026c9.6,9.596,16.957,20.636,21.996,32.392l-17.592-50.068 c-24.799-73.427-74.148-122.777-74.148-122.777s-3.562,3.574-9.148,7.444C337.156,99.738,370.908,141.995,390.084,198.765z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M280.738,125.018c0,0,19.441,25.116,21.439,61.75l0.523,2.843c5.094-1.332,10.264-2.312,15.475-2.843 c-2-36.633-21.441-61.75-21.441-61.75c-5.514,0-10.857-0.777-15.996-2.188V125.018z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M377.687,362.176c32.713-32.634,38.875-81.742,18.48-120.617l-0.086-0.16c-4.717-8.959-10.873-17.438-18.395-24.956 c-8.873-8.877-19.035-15.837-29.83-20.797c-9.896-4.562-20.363-7.429-31.002-8.678c18.613-2.16,37.688,0.699,54.998,8.678 c10.795,4.96,20.957,11.919,29.83,20.797c7.521,7.518,13.676,15.997,18.395,24.956l0.086,0.16 c20.395,38.875,14.23,87.983-18.48,120.617l-145.73,145.729L377.687,362.176z"
});

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var SvgLovefire = function SvgLovefire(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.905 511.905",
    style: {
      enableBackground: "new 0 0 511.905 511.905"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC6E51"
    },
    d: "M406.08,198.765l17.592,50.068c-5.039-11.755-12.396-22.796-21.996-32.392 c-22.793-22.875-53.67-32.795-83.5-29.674c-2-36.633-21.441-61.75-21.441-61.75c-16.395,0-31.354-6.319-43.429-18.396 c-11.435-11.517-18.238-26.155-22.074-40.953c-27.432,24.316-61.426,61.348-83.742,109.979l-7.444,19.996 c-10.795,4.96-20.957,11.919-29.831,20.797c-7.521,7.518-13.677,15.997-18.395,24.956l11.998-40.875 C142.928,71.911,259.945,4.002,259.945,4.002s-8.241,55.751,15.996,79.985c24.238,24.233,55.99-7.999,55.99-7.999 S381.281,125.338,406.08,198.765z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref2), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.949,210.287l2.867-9.764c29.876-98.27,105.198-161.051,139.098-185.226 c0.398-6.831,1.031-11.294,1.031-11.294s-117.017,67.908-156.127,196.52L91.82,241.398c4.718-8.959,10.873-17.438,18.395-24.956 C112.387,214.274,114.637,212.224,116.949,210.287z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCE54"
    },
    d: "M296.734,125.018c0,0,19.441,25.116,21.441,61.75c-22.715,2.32-44.797,12.236-62.23,29.674 c-31.354-31.436-77.907-38.313-115.9-20.797l7.444-19.996c22.316-48.632,56.31-85.664,83.742-109.979 c3.835,14.798,10.639,29.436,22.074,40.953C265.381,118.699,280.34,125.018,296.734,125.018z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M163.487,175.649c19.074-41.566,46.655-74.58,71.408-98.501c-1.438-3.784-2.664-7.62-3.664-11.479 c-27.432,24.316-61.426,61.348-83.742,109.979l-7.444,19.996c5.936-2.738,12.099-4.808,18.364-6.351L163.487,175.649z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M318.176,186.768c29.83-3.121,60.707,6.799,83.5,29.674c9.6,9.596,16.957,20.636,21.996,32.392 l4.482,12.881l0.156,0.477c9.357,34.474,0.484,72.95-26.635,99.984l-145.73,145.729l-145.73-145.729 c-32.712-32.634-38.875-81.742-18.48-120.617l0.086-0.16c4.718-8.959,10.873-17.438,18.395-24.956 c8.874-8.877,19.036-15.837,29.831-20.797c37.993-17.517,84.546-10.639,115.9,20.797 C273.379,199.004,295.461,189.088,318.176,186.768z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M134.211,362.176c-32.712-32.634-38.875-81.742-18.481-120.617l0.086-0.16 c4.718-8.959,10.873-17.438,18.395-24.956c8.874-8.877,19.036-15.837,29.831-20.797c9.896-4.562,20.363-7.429,31.002-8.678 c-18.614-2.16-37.688,0.699-54.998,8.678c-10.795,4.96-20.957,11.919-29.831,20.797c-7.521,7.518-13.677,15.997-18.395,24.956 l-0.086,0.16c-20.395,38.875-14.231,87.983,18.48,120.617l145.73,145.729L134.211,362.176z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _ref4), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M255.953,511.905c-1.023,0-2.047-0.391-2.828-1.172l-145.776-145.73 c-20.223-20.207-31.361-47.084-31.361-75.688s11.139-55.481,31.361-75.688c20.223-20.25,47.124-31.4,75.735-31.4 c27.292,0,53.013,10.15,72.869,28.667c19.847-18.516,45.578-28.667,72.861-28.667c28.611,0,55.496,11.154,75.703,31.404 c20.246,20.199,31.4,47.081,31.4,75.685s-11.154,55.489-31.408,75.696L258.781,510.733 C258,511.515,256.976,511.905,255.953,511.905z M183.084,190.224c-26.472,0-51.365,10.318-70.08,29.057 c-18.715,18.696-29.018,43.569-29.018,70.033s10.303,51.334,29.018,70.034l142.949,142.903l142.91-142.902 c18.738-18.7,29.057-43.57,29.057-70.034s-10.318-51.333-29.057-70.029c-18.707-18.742-43.578-29.061-70.049-29.061 c-26.465,0-51.334,10.318-70.033,29.053c-1.5,1.508-4.164,1.508-5.664,0C234.426,200.543,209.548,190.224,183.084,190.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M103.795,204.487c-0.382,0-0.773-0.055-1.164-0.172c-2.109-0.645-3.304-2.878-2.664-4.991 C139.116,70.688,256.766,1.229,257.953,0.542c1.32-0.77,2.977-0.719,4.248,0.152c1.273,0.859,1.938,2.375,1.711,3.894 c-0.078,0.535-7.654,54.045,14.873,76.571c5.287,5.288,11.154,7.862,17.918,7.862c0.031,0,0.055,0,0.078,0 c16.512-0.047,32.158-15.685,32.314-15.841c0.758-0.758,1.977-1.102,2.852-1.191c1.053,0,2.076,0.422,2.826,1.172 c0.5,0.5,50.248,50.814,75.057,124.281c0.703,2.093-0.422,4.362-2.508,5.069c-2.125,0.714-4.373-0.418-5.068-2.507 c-20.926-61.973-60.027-107.058-70.502-118.407c-5.914,5.112-19.678,15.36-34.908,15.423c-8.975-0.055-16.91-3.397-23.715-10.205 c-19.8-19.801-19.339-58.04-18.019-75.009c-25.464,16.833-114.713,82.156-147.487,189.846 C107.099,203.378,105.513,204.487,103.795,204.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A3847"
    },
    d: "M147.435,179.633c-0.562,0-1.133-0.117-1.672-0.367c-2.007-0.926-2.882-3.3-1.96-5.308 c23.222-50.385,58.895-88.323,84.733-111.279c1.031-0.918,2.46-1.25,3.812-0.836c1.336,0.402,2.359,1.469,2.711,2.816 c4.233,16.188,11.333,29.354,21.098,39.129c11.287,11.271,25.308,17.231,40.546,17.231c2.211,0,4,1.789,4,4 c0,2.21-1.789,3.999-4,3.999c-17.41,0-33.385-6.769-46.202-19.574c-9.475-9.487-16.653-21.754-21.371-36.521 c-24.753,22.742-56.802,58.247-78.063,104.386C150.395,178.769,148.951,179.633,147.435,179.633z"
  })), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLovefire, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lovefire.824f8966.svg";
export { ForwardRef as ReactComponent };